import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, ButtonGroup, Col, Container, FloatingLabel, Form, Image, InputGroup, Row, Spinner, ToggleButton } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useParams } from 'react-router-dom';
import { Link, useNavigate } from 'react-router-dom';
import { Iobserver, LoginInfo, SearchList } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import Thumb from './common/Thumb';
import Masonry from 'react-masonry-css';
import Tile from './common/Tile';
import { Typeahead } from 'react-bootstrap-typeahead';
import { isLoggin, updateRenzoku, updateTile } from '../service/LoginService';
import ReactGA from "react-ga4";
import TaggedImageSlider from './common/TaggedImageSlider';

const Search = () => {
    function search(postType,keyword,style,nenrei,follow,auth,aiOrModel,user,tag,postDateFrom,postDateTo,order,page){
        setSearching(true)
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/"+postType+"/search/",
            {keyword:keyword,style:style,ageLimit:nenrei,follow:follow,auth:auth,aiOrModel:aiOrModel,user:user,tag:tag,postDateFrom:postDateFrom,postDateTo:postDateTo,order:order,page:page}
        ).then((r)=>r.json().then((json)=>{
            setResultPostType(radioPostType)
            setSearching(false)
            return json
        }))
    }
    function modelSearch(word){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/model/",{word:word}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function userSearch(word){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/search/",{word:word}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function tagSearch(word){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tag/search/",{word:word}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    useEffect(() => {
        if(loginInfo.result){
            // 連続投稿の表示減らす
            setOmitContinuous(loginInfo.renzoku === 1)
            // タイルモード
            setTileMode(loginInfo.tile === 1)
        }
    },[loginInfo])

    // ナビゲーション
    const navigate = useNavigate();
    // 検索結果情報
    const {searchResultList,setSearchResultList,searchPage,setSearchPage} = useContext(SearchList)
    // 検索ワード
    let param = useParams()
    let keyword = param.keyword
    let page = parseInt(param.page)

    // 画像遅延ロード
    const observer = useContext(Iobserver)

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    })

    useEffect(() => {
        ReactGA.initialize("G-7W9JKQ50Y6");
        ReactGA.send({
          hitType: "pageview",
          // アクセスしたパス (pathname) とクエリ文字列 (search) を送付する (必要に応じて編集する)
          page: "/search",
        })
    },[])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // 検索結果セット
    function resultSet(json){
        if(json.result){
            setSearchResultList(json.data)
        } else {
            setSearchResultList([])
            setSearchPage(1)
        }
        // スクロールを最上位に戻す
        window.scrollTo({top:0,left:0,behavior:"instant"})
    }

    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(true)
    const breakpointColumnsObj = {
        default: 9,
        1800: 8,
        1600: 7,
        1400: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
    }
    const [radioPostType,setRadioPostType] = useState("image")
    const [resultPostType,setResultPostType] = useState("image")
    const [radioAgeLimit1,setRadioAgeLimit1] = useState(true)
    const [radioAgeLimit2,setRadioAgeLimit2] = useState(false)
    const [radioAgeLimit3,setRadioAgeLimit3] = useState(false)
    const [radioAgeLimit4,setRadioAgeLimit4] = useState(false)
    const [radioAgeLimit5,setRadioAgeLimit5] = useState(false)
    const [radioStyleOfPainting1,setRadioStyleOfPainting1] = useState(true)
    const [radioStyleOfPainting2,setRadioStyleOfPainting2] = useState(false)
    const [radioStyleOfPainting3,setRadioStyleOfPainting3] = useState(false)
    const [radioFollow,setFollow] = useState("3")
    const [radioAuth,setRadioAuth] = useState(false)
    const postTypes = [
        { name: t("upload.image.title"), value: "image"},
        { name: t("upload.video.title"), value: "video"},
        { name: t("upload.text.title"), value: "text"},
    ]
    const style = [
        { name: t("common.illustration"), value: 1,checked:radioStyleOfPainting1,set:setRadioStyleOfPainting1 },
        { name: t("common.semirealism"), value: 3,checked:radioStyleOfPainting3,set:setRadioStyleOfPainting3 },
        { name: t("common.photorealistic"), value: 2,checked:radioStyleOfPainting2,set:setRadioStyleOfPainting2 },
    ]
    const nenrei = [
        { name: t("upload.image.ageLimitG"), value: 1,checked:radioAgeLimit1,set:setRadioAgeLimit1 },
        { name: "PG-12", value: 2,checked:radioAgeLimit2,set:setRadioAgeLimit2 },
        { name: "R-15", value: 3,checked:radioAgeLimit3,set:setRadioAgeLimit3 },
        { name: "R-18", value: 4,checked:radioAgeLimit4,set:setRadioAgeLimit4 },
        { name: "R-18G", value: 5,checked:radioAgeLimit5,set:setRadioAgeLimit5 }
    ]
    const follow = [
        { name: t("common.followed"), value: "1"},
        { name: t("common.notFollowed"), value: "2"},
        { name: t("common.unselected"), value: "3"},
    ]
    const auth = [
        { name: t("common.certified"), value: 1,checked:radioAuth,set:setRadioAuth },
    ]
    const [aiOrModel, setAIOrModel] = useState([])
    const [modelOptions, setModelOptions] = useState([])
    const [userOptions, setUserOptions] = useState([])
    const [tagOptions, setTagOptions] = useState([])
    const [user, setUser] = useState([])
    const [tag, setTag] = useState([])
    const [postDateFrom, setPostDateFrom] = useState("")
    const [postDateTo, setPostDateTo] = useState("")
    const [order, setOrder] = useState([])
    const [showSearchDialog,setShowSearchDialog] = useState(false)
    const [searching,setSearching] = useState(false)

    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = keyword + "の画像 - アワートAI"
        setSearchPage(page)
        search(radioPostType,keyword,style,nenrei,radioFollow,auth,aiOrModel,user,tag,postDateFrom,postDateTo,order,page).then(json=>{
            if(json.result){
                resultSet(json)
            } else {
                dialog(t("common.error"),json.errors)
            }
        })
    },[keyword,page])
    function getStyleChecked(radio){
        let value = 0
        if(radio.value === 1){
            value = style[0].checked
        } else if(radio.value === 3){
            value = style[1].checked
        } else {
            value = style[2].checked
        }
        return value
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <Container className='mt-3 mb-3 d-none' style={{fontSize:"24px",fontWeight:"bold",borderLeft:"10px solid lightblue"}}>
            <Icon.Search style={{paddingBottom:"5px",color:"orange"}} /> {t("common.searchOption")}
        </Container>
        <Container className='p-0'>
            <Button onClick={() => setShowSearchDialog(true)}>詳細検索</Button>
        </Container>
        <Container>
            <div className='p-3' style={{position:"fixed",zIndex:3,backgroundColor:"#FFFFFF",left:0,top:0,opacity:0.7,width:"100%",height:"100%",display:showSearchDialog ? "block" : "none"}}
                onClick={(e) => {
                    setShowSearchDialog(false)
                }}
            />
            <Container style={{position:"absolute",zIndex:3,top:window.scrollY,height:"100%",overflow:"auto",backgroundColor:"#FFFFFF",display:showSearchDialog ? "block" : "none"}}
                className="w-100"
            >
            <Container className='mt-4 mb-3 d-flex justify-content-between' style={{fontSize:"24px",fontWeight:"bold",borderLeft:"10px solid lightblue",borderBottom:"3px solid lightblue"}}>
                <span><Icon.Search style={{paddingBottom:"5px",color:"orange"}} /> 検索設定</span>
                <Button variant='outline-secondary' style={{fontSize:"18px"}} className="mb-1"
                    onClick={(e) => {
                        setShowSearchDialog(false)
                    }}
                >{t("common.close")}</Button>
            </Container>
            <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={12} style={{margin:"0 auto",width:"100%"}} className="d-block">
                    <Container className="p-0">
                        <ButtonGroup style={{}} className="mb-2">
                            {postTypes.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`post-type-${idx}`}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name={`post-type-${idx}`}
                                    value={radio.value}
                                    checked={radioPostType === radio.value}
                                    onChange={(e) => {
                                        setRadioPostType(e.currentTarget.value)
                                    }}
                                    >
                                    {radio.name}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                        &nbsp;
                        <ButtonGroup style={{}} className="mb-2">
                            {style.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`style-of-painting-${idx}`}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name={`style-of-painting-${idx}`}
                                    value={radio.value}
                                    checked={
                                        getStyleChecked(radio)
                                        //style[radio.value -1].checked
                                    }
                                    onClick={(e) => {
                                        if(radio.value === 1){
                                            style[0].set(!style[0].checked)    
                                            console.log(style[0].name)
                                        } else if(radio.value === 3){
                                            style[1].set(!style[1].checked)    
                                            console.log(style[1].name)
                                        } else {
                                            style[2].set(!style[2].checked)    
                                            console.log(style[2].name)
                                        }
                                        console.log(radio.value)
                                        //style[radio.value - 1].set(!style[radio.value - 1].checked)
                                    }}
                                    >
                                    {radio.name}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                        &nbsp;
                        <ButtonGroup className="mb-2">
                            {nenrei.filter(d => {
                                if(loginInfo.userId === undefined){
                                    return false
                                } else {
                                    return d.value === 1 && (loginInfo.pg12_display_flag === 1 || loginInfo.r15_display_flag === 1 || loginInfo.r18_display_flag === 1 || loginInfo.r18g_display_flag === 1)
                                    || loginInfo.pg12_display_flag === 1 && d.value === 2
                                    || loginInfo.r15_display_flag === 1 && d.value === 3
                                    || loginInfo.r18_display_flag === 1 && d.value === 4
                                    || loginInfo.r18g_display_flag === 1 && d.value === 5
                                }
                            }).map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`age-limit-${idx}`}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name={`age-limit-${idx}`}
                                    value={radio.value}
                                    checked={nenrei[radio.value - 1].checked}
                                    onClick={(e) => {
                                        nenrei[radio.value - 1].set(!nenrei[radio.value - 1].checked)
                                    }}
                                    >
                                    {radio.name}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                        &nbsp;
                        <ButtonGroup className="mb-2" style={{display:loginInfo.result === false ? "none" : "inline-block"}}>
                            {follow.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`follow-${idx}`}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name={`follow-radio`}
                                    value={radio.value}
                                    checked={radioFollow === radio.value}
                                    onChange={(e) => {
                                        setFollow(e.currentTarget.value)
                                    }}
                                    >
                                    {radio.name}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                        &nbsp;
                        <ButtonGroup style={{}} className="mb-2">
                            {auth.map((radio, idx) => (
                                <ToggleButton
                                    key={idx}
                                    id={`auth-${idx}`}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name={`auth-${idx}`}
                                    value={radio.value}
                                    checked={auth[radio.value - 1].checked}
                                    onClick={(e) => {
                                        auth[radio.value - 1].set(!auth[radio.value - 1].checked)
                                    }}
                                    >
                                    {radio.name}
                                </ToggleButton>
                            ))}
                        </ButtonGroup>
                    </Container>
                    <Typeahead id="ai-model-input" placeholder={"利用サービスまたはモデル"} clearButton={true} multiple
                    onInputChange={(input) => {
                        modelSearch(input).then(r => {
                            if(r.result){
                                setModelOptions(r.data)
                            }
                        })
                    }}
                    onChange={(selected) => {
                        setAIOrModel(selected)
                        // let value = selected.length === 0 ? "no-select" : selected[0]
                        // if(fileList.length > 0){
                        //     fileList[editImageNo].software = value
                        // }
                        // document.getElementById("ai-model").value = value
                    }}
                    options={modelOptions}
                    />
                    &nbsp;
                    <Typeahead id="username" placeholder={"ユーザー名"} clearButton={true} multiple
                    onInputChange={(input) => {
                        userSearch(input).then(r => {
                            if(r.result){
                                setUserOptions(r.data.map(d => d.user_name))
                            }
                        })
                        // let value = input === undefined ? "no-select" : input
                        // if(fileList.length > 0){
                        //     fileList[editImageNo].software = value
                        // }
                        // document.getElementById("ai-model").value = value
                    }}
                    onChange={(selected) => {
                        setUser(selected)
                        // let value = selected.length === 0 ? "no-select" : selected[0]
                        // if(fileList.length > 0){
                        //     fileList[editImageNo].software = value
                        // }
                        // document.getElementById("ai-model").value = value
                    }}
                    options={userOptions}
                    />
                    &nbsp;
                    <Typeahead id="tag" placeholder={"タグ"} clearButton={true} multiple
                    onInputChange={(input) => {
                        tagSearch(input).then(r => {
                            if(r.result){
                                setTagOptions(r.data)
                            }
                        })
                        // let value = input === undefined ? "no-select" : input
                        // if(fileList.length > 0){
                        //     fileList[editImageNo].software = value
                        // }
                        // document.getElementById("ai-model").value = value
                    }}
                    onChange={(selected) => {
                        setTag(selected)
                        // let value = selected.length === 0 ? "no-select" : selected[0]
                        // if(fileList.length > 0){
                        //     fileList[editImageNo].software = value
                        // }
                        // document.getElementById("ai-model").value = value
                    }}
                    options={tagOptions}
                    />
                    <Container className='p-0 mt-3'>
                        投稿日
                        <Row>
                            <Col xs={5} sm={5} md={5} lg={5} xl={5} xxl={5}>
                                <FloatingLabel controlId="post-date-from" label={t("common.postDateFrom")} className='mb-3'>
                                    <Form.Control
                                        type="date"
                                        required
                                        defaultValue={postDateFrom}
                                        onChange={(e) => setPostDateFrom(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={1} sm={1} md={1} lg={1} xl={1} xxl={1}>～</Col>
                            <Col xs={5} sm={5} md={5} lg={5} xl={5} xxl={5}>
                            <FloatingLabel controlId="post-date-to" label={t("common.postDateTo")} className='mb-3'>
                                <Form.Control
                                    type="date"
                                    required
                                    defaultValue={postDateTo}
                                    onChange={(e) => setPostDateTo(e.currentTarget.value)}
                                />
                            </FloatingLabel>
                            </Col>
                        </Row>
                    </Container>
                    &nbsp;
                    <Typeahead id="order" placeholder={"並び順"} clearButton={true} multiple
                    onInputChange={(input) => {
                        // let value = input === undefined ? "no-select" : input
                        // if(fileList.length > 0){
                        //     fileList[editImageNo].software = value
                        // }
                        // document.getElementById("ai-model").value = value
                    }}
                    onChange={(selected) => {
                        if(selected.length !== new Set(selected.map(d => d.order.split("_")[0])).size){
                            dialog(t("common.error"),"同じ項目に対して昇順と降順の両方が指定されているため、どちらか一つにしてください。")
                            if(selected.length > 1){
                                selected.pop()
                                setOrder(selected)
                            }
                            return
                        } else {
                            setOrder(selected)
                        }
                        // let value = selected.length === 0 ? "no-select" : selected[0]
                        // if(fileList.length > 0){
                        //     fileList[editImageNo].software = value
                        // }
                        // document.getElementById("ai-model").value = value
                    }}
                    options={[
                        {order:"postdate_desc",label:"投稿日時(新しい順)"},
                        {order:"postdate_asc",label:"投稿日時(古い順)"},
                        {order:"favorite_desc",label:"いいねの数(多い順)"},
                        {order:"favorite_asc",label:"いいねの数(少ない順)"},
                        {order:"pv_desc",label:"閲覧数(多い順)"},
                        {order:"pv_asc",label:"閲覧数(少ない順)"},
                        {order:"osusume",label:"おすすめ"},
                        {order:"random",label:"ランダム"},
                    ]}
                    selected={order}
                    />
                </Col>
            </Row>
            <Button className='mt-3' variant='outline-primary'
            onClick={() => {
                let keyword = document.querySelector("#keyword").value
                setSearchPage(1)
                navigate("/search/"+keyword+"/1")
                search(radioPostType,keyword,style,nenrei,radioFollow,auth,aiOrModel,user,tag,postDateFrom,postDateTo,order,1).then(json=>{
                    if(json.result){
                        resultSet(json)
                        setShowSearchDialog(false)
                    } else {
                        dialog(t("common.error"),json.errors)
                    }
                })
            }}
            disabled={searching}
            >{t("header.search")} {searching ? <Spinner animation="border" size="sm" /> : ""}</Button>
            </Container>
        </Container>
        <Container className='mt-3 mb-3' style={{fontSize:"24px",fontWeight:"bold",borderLeft:"10px solid lightblue"}}>
            <Icon.ImageFill style={{paddingBottom:"5px",color:"orange"}} /> {t("common.searchResults")}「{keyword}」
        </Container>
        <div>
            <TaggedImageSlider />
        </div>
        <Container className='d-flex p-0'>
            <Row>
                <Col xs={8} sm={8} md={7} lg={7} xl={7} xxl={7} style={{}}>
                    <InputGroup style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={omitContinuous} onClick={(e) => {
                            updateRenzoku(e.currentTarget.checked ? "on" : "off").then(r => {
                                if(r.result){
                                    isLoggin().then(json => {
                                        setLoginInfo(json)
                                    })
                                }
                            })
                            //setOmitContinuous(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.deduceConsecutiveSubmissions")} readOnly />
                    </InputGroup>
                </Col>
                <Col xs={8} sm={8} md={5} lg={5} xl={5} xxl={5} style={{}}>
                    <InputGroup style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={tileMode} onClick={(e) => {
                            updateTile(e.currentTarget.checked ? "on" : "off").then(r => {
                                if(r.result){
                                    isLoggin().then(json => {
                                        setLoginInfo(json)
                                    })
                                }
                            })
                            //setTileMode(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.tileMode")} readOnly />
                    </InputGroup>
                </Col>
            </Row>
        </Container>
        <Container>
            {searching ? <Spinner animation="border" size="lg" className='m-3' /> : ""}
        </Container>
        {tileMode ? (
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
                >
                {searchResultList.map((data,i) => {
                    if(i === 101){
                        return ""
                    }
                    if(data.mute === 1 || (omitContinuous && i > 0 && searchResultList[i-1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)){
                        return <span data-no={i} className="lazy" key={i}></span>
                    }
                    if(resultPostType === "video"){
                        data.id = data.group_id
                    }
                    return <Tile type={resultPostType} data={data} i={i} dialog={dialog} key={i} list={searchResultList} listName={t(("category.search"))} />
                })}
            </Masonry>
        ) : (
        <div className='d-flex flex-row justify-content-start flex-wrap w-100'>
            {searchResultList.map((data,i) => {
                if(i === 101){
                    return ""
                }
                if(data.mute === 1 || (omitContinuous && i > 0 && searchResultList[i-1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)){
                    return <span data-no={i} className="lazy" key={i}></span>
                }
            return <Thumb type={resultPostType} data={data} i={i} dialog={dialog} key={i} list={searchResultList} listName={t(("category.search"))} />
            })}
        </div>
        )}
        <Container className='d-flex justify-content-between' style={{width:"200px"}}>
            {page > 1 ? (
                    <Button onClick={() => {
                        let keyword = param.keyword
                        let page = searchPage - 1
                        setSearchPage(page)
                        navigate("/search/" + keyword + "/" + page)
                    } }>{t("common.prev")}</Button>
                ) : <Button disabled>{t("common.prev")}</Button>}
            {searchResultList.length > 12 ? (
                    <Button onClick={() => {
                        let keyword = param.keyword
                        let page = searchPage + 1
                        setSearchPage(page)
                        navigate("/search/" + keyword + "/" + page)
                    } }>{t("common.next")}</Button>
                ) : <Button disabled>{t("common.next")}</Button>}
        </Container>
        <Footer />
    </div>
    )
}

export default Search;
